<script setup>
import LatexDisplay from '@/components/LatexDisplay.vue';
import SpeakText from '@/components/SpeakText.vue';

defineProps({
    question: {},
});
</script>
<script>
export default {
    name: 'QuestionDescriptionDisplay',
};
</script>

<template>
    <LatexDisplay :model-value="question.description" v-if="question.is_latex" />
    <template v-else>
        <SpeakText :text="question.description" :lang="question.locale" class="prose prose-sm" />
    </template>
</template>

<style scoped></style>
